import moment from 'moment';

import { CalendarLegacy } from '@dreryk/react-components';

type MiniCalendarProps = {
   readonly currentDate: Date;
   readonly onDateChange: (date: Date) => void;
   readonly rangeSelector?: (day: moment.Moment) => boolean;
};

export const MiniCalendar = (props: MiniCalendarProps): JSX.Element => {
   return (
      <CalendarLegacy
         date={props.currentDate}
         onDateChange={props.onDateChange}
         isDayHighlighted={props.rangeSelector}
         testId={'miniCalendar'}
      />
   );
};
